import React from "react";

function GeneDispo() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <g transform="translate(-1065.000000, -341.000000) translate(1065.000000, 293.000000) translate(0.000000, 48.000000)">
                            <rect width="42" height="42" fill="#00BF9D" opacity=".09" rx="4" />
                            <g fillRule="nonzero">
                                <path
                                    fill="#00BF9D"
                                    d="M28.8 0H3.6v3.6H0v15.6h25.2v-3.6h3.6V0zM24 18H1.2V4.8H24V18zm3.6-3.6h-2.4V3.6H4.8V1.2h22.8v13.2z"
                                    transform="translate(7.000000, 11.000000)"
                                />
                                <path
                                    fill="#4FBDCE"
                                    d="M12.6 15.6c2.32 0 4.2-1.88 4.2-4.2 0-2.32-1.88-4.2-4.2-4.2-2.32 0-4.2 1.88-4.2 4.2 0 2.32 1.88 4.2 4.2 4.2zm0-7.2c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3z"
                                    transform="translate(7.000000, 11.000000)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default GeneDispo;
